<template>
  <div>
    <!-- Title -->
    <drop-down-menu-item :type="'title'">
      {{ sectionContent.title }}
    </drop-down-menu-item>

    <!-- Gift Card Scan to Pay -->
    <drop-down-menu-item
      v-if="isGiftCardScanToPayEnabled"
      :type="'routerLink'"
      :link-to="giftCardPaymentScanningNavigationLink"
      :icon-class="'far fa-qrcode'"
    >
      {{ sectionContent.scanGiftCards }}
    </drop-down-menu-item>

    <!-- Scan to Pay -->
    <drop-down-menu-item
      v-if="isSingleScanEnabled"
      :type="'routerLink'"
      :link-to="scanToPayNavigationLink"
      :icon-class="'far fa-qrcode'"
    >
      {{ sectionContent.scanAndPay }}
    </drop-down-menu-item>

    <!-- "Standard" Menu -->
    <drop-down-menu-item
      :type="'button'"
      :icon-class="'far fa-utensils'"
      @click="standardMenuClickHandler"
    >
      {{ sectionContent.browseMenu }}
    </drop-down-menu-item>

    <!-- Catering Menu -->
    <drop-down-menu-item
      v-if="isCateringMenuEnabled"
      :type="'button'"
      :icon-class="'far fa-hat-chef'"
      @click="cateringMenuClickHandler"
    >
      {{ sectionContent.browseCateringMenu }}
    </drop-down-menu-item>

    <!-- Group Order -->
    <drop-down-menu-item
      v-if="isGroupOrderingEnabled"
      :type="'button'"
      :icon-class="'far fa-users'"
      @click="groupOrderClickHandler"
    >
      {{ sectionContent.groupOrder }}
    </drop-down-menu-item>

    <!-- Store Locations-->
    <drop-down-menu-item
      v-if="isStoreLocationsEnabled"
      :type="'routerLink'"
      :link-to="merchantLocationsNavigationLink"
      :icon-class="'far fa-store-alt'"
    >
      {{ sectionContent.merchantLocations }}
    </drop-down-menu-item>

    <!-- Gift Card Gifting -->
    <drop-down-menu-item
      v-if="isGiftCardGiftingEnabled"
      :type="'routerLink'"
      :link-to="giftCardGiftingNavigationLink"
      :icon-class="'far fa-gift-card'"
    >
      {{ sectionContent.sendGiftCard }}
    </drop-down-menu-item>

    <!-- Check Gift Card Balance -->
    <drop-down-menu-item
      v-if="isGiftCardManagementEnabled"
      :type="'button'"
      :icon-class="'far fa-gift-card'"
      @click="checkGiftCardBalanceClickHandler"
    >
      <!-- Check Gift Card Balance -->
      {{ sectionContent.checkGiftCardBalance }}
    </drop-down-menu-item>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import orderModeNavigationMixin from '@/mixins/order-mode-navigation';

  import DropDownMenuItem from '../drop-down-menu-item/index.vue';


  export default {
    name: 'MainNavigation',

    components: {
      DropDownMenuItem
    },

    mixins: [orderModeNavigationMixin],

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('giftCards', ['giftCardGiftingEnabled', 'giftCardManagementEnabled']),
      ...mapGetters('merchant', ['loyaltyOptions', 'merchant']),
      ...mapGetters('orders', ['order', 'showCateringMenuButton', 'showGroupOrderButton']),

      sectionContent() {
        const content = this.content.MenuDropdown.metadata;

        return {
          title: content.titleNavigation,
          scanGiftCards: content.itemScanGiftCards,
          scanAndPay: content.ItemScanAndPay,
          browseMenu: content.itemBrowseMenu,
          browseCateringMenu: content.itemBrowseCateringMenu,
          groupOrder: content.itemGroupOrder,
          merchantLocations: content.locations || 'Locations',
          sendGiftCard: content.itemSendAGiftCard,
          checkGiftCardBalance: content.itemCheckGiftCardBalance
        };
      },

      isGiftCardScanToPayEnabled() {
        return this.merchant.features['enable-gift-card-scan'];
      },

      giftCardPaymentScanningNavigationLink() {
        return { name: 'GIFT_CARD_PAYMENT_SCANNING' };
      },

      isSingleScanEnabled() {
        return this.merchant.features['single-scan-enabled'];
      },

      scanToPayNavigationLink() {
        return { name: 'singleScanBarcode' };
      },

      isCateringMenuEnabled() {
        return this.showCateringMenuButton;
      },

      isGroupOrderingEnabled() {
        return this.showGroupOrderButton;
      },

      isStoreLocationsEnabled() {
        return this.merchant.features['disable-ordering'];
      },

      merchantLocationsNavigationLink() {
        return { name: 'locations' };
      },

      isGiftCardGiftingEnabled() {
        return this.giftCardGiftingEnabled;
      },

      isGiftCardManagementEnabled() {
        return this.giftCardManagementEnabled;
      },

      giftCardGiftingNavigationLink() {
        return { name: 'orderGifting' };
      }
    },

    methods: {
      groupOrderClickHandler() {
        this.$openModal('editGroupOrder');
      },

      checkGiftCardBalanceClickHandler() {
        this.$openModal('checkGiftCardBalanceModal');
      }
    }
  };
</script>
